// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-display:swap;font-family:\"Manrope\";font-weight:500;src:url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2 supports variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2-variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-Medium.woff2\") format(\"woff2\")}@font-face{font-display:swap;font-family:\"Manrope\";font-weight:600;src:url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2 supports variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2-variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-SemiBold.woff2\") format(\"woff2\")}.Message-box{align-items:center;border:1px solid #afbbca;display:flex;font-family:\"Manrope\",system-ui,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:16px;padding:8px 16px;padding-right:32px;position:relative;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;-webkit-transition:all 200ms ease-out;-moz-transition:all 200ms ease-out;-ms-transition:all 200ms ease-out;-o-transition:all 200ms ease-out;transition:all 200ms ease-out}.Message-box.closable .button.close-button{background-color:#f9fafb;display:inherit;padding:0;position:absolute;right:-10px;top:-10px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}.Message-box.closable .button.close-button .close-icon{border:2px solid #f9fafb;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}.Message-box .button.close-button{display:none}.Message-box .message{flex:1}.Message-box .message-icon{flex-basis:16px;margin-right:16px}.Message-box.hidden{display:none}.Message-box.-success{background-color:#e6f5ed;border:2px solid #61c194;color:#008651}.Message-box.-success .button.close-button{color:#61c194}.Message-box.-primary{background-color:#edf6fd;border:2px solid #74b6ee;color:#448ad9}.Message-box.-primary .button.close-button{color:#74b6ee}.Message-box.-error{background-color:#ffebed;border:2px solid #fc3d31;color:#db282b}.Message-box.-error .button.close-button{color:#fc3d31}.Message-box.-warning{background-color:#fff5e5;border:2px solid #ff9500;color:#f57902}.Message-box.-warning .button.close-button{color:#ff9500}", ""]);
// Exports
exports.locals = {
	"color900-accent": "#3600cd",
	"color900-brand": "#145739",
	"color900-negative": "#bf1217",
	"color900-primary": "#2b4a94",
	"color900-shade": "#262e3a",
	"color900-warm": "#e54d03",
	"color800-accent": "#5400d3",
	"color800-brand": "#1f7454",
	"color800-negative": "#ce2024",
	"color800-primary": "#3667b4",
	"color800-shade": "#4c5564",
	"color800-warm": "#ee6802",
	"color700-accent": "#6400d8",
	"color700-brand": "#008651",
	"color700-negative": "#db282b",
	"color700-primary": "#3c78c6",
	"color700-shade": "#7c8595",
	"color700-warm": "#f57902",
	"color600-accent": "#7400e1",
	"color600-brand": "#00985d",
	"color600-negative": "#ed3331",
	"color600-primary": "#448ad9",
	"color600-shade": "#a0a9b9",
	"color600-warm": "#fb8901",
	"color500-accent": "#7f00e7",
	"color500-brand": "#31a27c",
	"color500-negative": "#fc3d31",
	"color500-primary": "#4a98e7",
	"color500-shade": "#afbbca",
	"color500-warm": "#ff9500",
	"color400-accent": "#9542ec",
	"color400-brand": "#37b47e",
	"color400-negative": "#f84f4c",
	"color400-primary": "#5ca6ea",
	"color400-shade": "#cdd3da",
	"color400-warm": "#ffa425",
	"color300-accent": "#a969f0",
	"color300-brand": "#61c194",
	"color300-negative": "#ed7171",
	"color300-primary": "#74b6ee",
	"color300-shade": "#d4dae3",
	"color300-warm": "#ffb54c",
	"color200-accent": "#c297f4",
	"color200-brand": "#91d2b2",
	"color200-negative": "#f59999",
	"color200-primary": "#99cbf3",
	"color200-shade": "#e1e5ea",
	"color200-warm": "#ffca7f",
	"color100-accent": "#dac1f8",
	"color100-brand": "#bce4d0",
	"color100-negative": "#ffcdd2",
	"color100-primary": "#bfdef8",
	"color100-shade": "#f9fafb",
	"color100-warm": "#ffdfb1",
	"color050-accent": "#f4edfd",
	"color050-brand": "#e6f5ed",
	"color050-negative": "#ffebed",
	"color050-primary": "#edf6fd",
	"color050-shade": "#fff",
	"color050-warm": "#fff5e5"
};
module.exports = exports;
